<template>
  <div class="toast-container">
    <div
      id="internet_connection_status_toast"
      class="toast bg-dark text-white border-none"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div class="toast-body p-4">
        <div class="d-flex justify-content-between gap-3 gap-md-4">
          <div class="d-inline-block">
            <i
              class="fas fa-wifi me-3"
              :class="is_online == true ? 'text-success' : 'text-muted'"
            ></i>
            {{ internet_connection_status_toast_message }}
          </div>
          <div class="d-inline-block">
            <a
              href="#"
              type="button"
              class="text-white"
              data-bs-dismiss="toast"
              aria-label="Close"
            >
              <i class="fas fa-times"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InternetConnectionStatusToast",
  data: () => ({
    is_online: navigator.onLine,
    internet_connection_status_toast_message: "",
  }),
  methods: {
    updateOnlineStatus(e) {
      const { type } = e;
      this.is_online = type === "online";
    },
  },
  watch: {
    is_online(v) {
      if (v === false) {
        this.internet_connection_status_toast_message =
          "You're disconnected from the internet.";

        var myAlert = document.getElementById("internet_connection_status_toast");
        var bsAlert = new bootstrap.Toast(myAlert);
        bsAlert.show();
      } else {
        location.reload();
        this.internet_connection_status_toast_message =
          "Your internet connection was restored.";

        var myAlert = document.getElementById("internet_connection_status_toast");
        var bsAlert = new bootstrap.Toast(myAlert);
        bsAlert.show();
      }
    },
  },
  mounted() {
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },
};
</script>
